// Web stub for react-native-device-country
export const TYPE_CONFIGURATION = {
  IOS: 'iOS',
  ANDROID: 'Android',
};

export const DeviceCountry = {
  getCountryCode: async () => {
    // Return default currency code on web
    return 'USD';
  },
};

export default {
  TYPE_CONFIGURATION,
  DeviceCountry,
};
